import { createLayoutApp } from "../layout/createLayoutApp";
import ExchangeRatesAppDesktop from "../exchangeRates/ExchangeRatesAppDesktop.vue";
import { setDocumentControllerType } from "../util/controllerHelpers";

const mountEl = document.getElementById("exchange-rates-app");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  setDocumentControllerType("desktop");
  const app = createLayoutApp(ExchangeRatesAppDesktop);
  app.config.globalProperties.$mobile = false;
  app.mount(mountEl);
}
